import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCountry, fetchCountryList, selectCountryList, selectIsFailureCountryList, selectIsFetchingCountryList, selectIsLoadedCountryList, selectIsToRefetchCountryList } from '@gandi/redux-places';
const EMPTY_COUNTRY = {
  alpha2: '',
  name: '',
  href: ''
};
function fetchCountryListIfNecessary() {
  return (dispatch, getState) => {
    const state = getState();
    const shouldFetch = (!selectIsLoadedCountryList(state) && !selectIsFailureCountryList(state) || selectIsToRefetchCountryList(state)) && !selectIsFetchingCountryList(state);
    if (shouldFetch) {
      return dispatch(fetchCountryList());
    }
    return Promise.resolve();
  };
}
export default function useCountries(defaultUserCountry) {
  const dispatch = useDispatch();
  const isFailureCountries = useSelector(selectIsFailureCountryList);
  const isFetchingCountries = useSelector(selectIsFetchingCountryList);
  const isLoadedCountries = useSelector(selectIsLoadedCountryList);
  const isToRefetchCountries = useSelector(selectIsToRefetchCountryList);
  const shouldFetchCountries = (!isLoadedCountries && !isFailureCountries || isToRefetchCountries) && !isFetchingCountries;
  const countries = useSelector(selectCountryList);
  React.useEffect(() => {
    if (shouldFetchCountries) {
      dispatch(fetchCountryListIfNecessary());
    }
  }, [dispatch, shouldFetchCountries]);
  const [userCountry, setUserCountry] = React.useState();
  React.useEffect(() => {
    if (defaultUserCountry && !userCountry) {
      setUserCountry(EMPTY_COUNTRY);
      const defaultCountry = countries.find(country => country.alpha2 === defaultUserCountry);
      if (!defaultCountry) {
        dispatch(fetchCountry(defaultUserCountry)).then(resp => {
          setUserCountry(resp ? resp.data : EMPTY_COUNTRY);
        });
      } else {
        setUserCountry(defaultCountry);
      }
    }
  }, [countries, defaultUserCountry, dispatch, userCountry]);
  return {
    countries,
    isFailureCountries,
    isFetchingCountries,
    isLoadedCountries,
    isToRefetchCountries,
    shouldFetchCountries,
    userCountry,
    userCountries: userCountry && userCountry.alpha2 && userCountry.name ? [userCountry, ...countries] : countries
  };
}